<script setup lang="ts">
import { bemBuilder } from "@chatfood/core-utils";
import { MenuSelector } from "~/components/menu-selector";
import { useOutletStore } from "~/stores/outlet";
import type { IDomainOrderingMode } from "~/domain/ordering-mode";

const css = bemBuilder("pages-menus");

const props = defineProps<{
  orderingMode: IDomainOrderingMode;
  outletSlug: string;
}>();

const outlet = useOutletStore();
</script>

<template>
  <MenuSelector
    :class="css()"
    :outlet-id="outlet.id"
    :ordering-mode="props.orderingMode"
  />
</template>
